export default "__VITE_ASSET__D0UKJkM4__"